import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { Button } from '../components/ui/button';
import { referenzenContent } from '../data/pageContent';

const ReferenzenPage = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="referenzen-page">
      {/* Schemas werden ausschliesslich via SSG geliefert - keine Duplikate durch React */}
      
      <Header />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="bg-gradient-to-b from-[#f4f5f3] to-white py-12 md:py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#1a1c1b] mb-6 leading-tight">
              {referenzenContent.h1}
            </h1>
            
            {/* Hero Image */}
            <div className="mb-8 rounded-2xl overflow-hidden shadow-lg">
              <img 
                src={referenzenContent.heroImage.src}
                alt={referenzenContent.heroImage.alt}
                className="w-full h-auto object-cover"
                loading="eager"
              />
            </div>
            
            <p className="text-lg text-[#333] leading-relaxed">
              {referenzenContent.intro}
            </p>
          </div>
        </section>
        
        {/* Case Studies */}
        <section className="py-12 md:py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6">
            {referenzenContent.cases.map((caseStudy, index) => (
              <article key={caseStudy.id} id={caseStudy.id} className="mb-16 last:mb-0 scroll-mt-24">
                <h2 className="text-2xl sm:text-3xl font-bold text-[#1a1c1b] mb-4">
                  {caseStudy.title}
                </h2>
                
                <p className="text-[#333] leading-relaxed mb-6">
                  {caseStudy.intro}
                </p>
                
                <h3 className="text-xl font-bold text-[#1a1c1b] mb-3">Ausgangslage</h3>
                <p className="text-[#333] leading-relaxed mb-6">
                  {caseStudy.ausgangslage}
                </p>
                
                <h3 className="text-xl font-bold text-[#1a1c1b] mb-3">Herausforderung</h3>
                <p className="text-[#333] leading-relaxed mb-6">
                  {caseStudy.herausforderung}
                </p>
                
                <h3 className="text-xl font-bold text-[#1a1c1b] mb-3">Vorgehen</h3>
                <ul className="space-y-3 mb-6">
                  {caseStudy.vorgehen.map((step, stepIndex) => (
                    <li key={stepIndex} className="flex items-start gap-3">
                      <span className="flex-shrink-0 w-2 h-2 rounded-full bg-[#FF0000] mt-2"></span>
                      <span className="text-[#333]">
                        <strong className="text-[#1a1c1b]">{step.title}:</strong> {step.desc}
                      </span>
                    </li>
                  ))}
                </ul>
                
                <h3 className="text-xl font-bold text-[#1a1c1b] mb-3">Ergebnis</h3>
                <p className="text-[#333] leading-relaxed">
                  {caseStudy.ergebnis}
                </p>
                
                {index < referenzenContent.cases.length - 1 && (
                  <hr className="mt-12 border-gray-200" />
                )}
              </article>
            ))}
          </div>
        </section>
        
        {/* Closing Section */}
        <section className="py-12 bg-[#f4f5f3]">
          <div className="max-w-4xl mx-auto px-4 sm:px-6">
            <h2 className="text-2xl sm:text-3xl font-bold text-[#1a1c1b] mb-4">
              {referenzenContent.closingSection.title}
            </h2>
            <p className="text-[#333] leading-relaxed">
              {referenzenContent.closingSection.text}
            </p>
          </div>
        </section>
        
        {/* FAQ Section */}
        <section className="py-12 md:py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6">
            <h2 className="text-2xl sm:text-3xl font-bold text-[#1a1c1b] mb-8">
              Häufige Fragen zu Nachfolgelösungen
            </h2>
            
            <dl className="space-y-6">
              {referenzenContent.faq.map((item, index) => (
                <div key={index} className="border-b border-gray-200 pb-6 last:border-b-0">
                  <dt className="text-lg font-semibold text-[#1a1c1b] mb-2">
                    {item.question}
                  </dt>
                  <dd className="text-[#333] leading-relaxed">
                    {item.answer}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </section>
        
        {/* CTA Section */}
        <section className="py-12 bg-[#1a1c1b]">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
            <p className="text-white text-lg mb-6">
              {referenzenContent.ctaText}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/unternehmensbewertung">
                <Button className="bg-[#FF0000] hover:bg-[#CC0000] text-white px-6 py-3">
                  Unternehmen bewerten
                  <ArrowRight size={18} className="ml-2" />
                </Button>
              </Link>
              <Link to="/ma-beratung">
                <Button variant="outline" className="border-white text-white hover:bg-white hover:text-[#1a1c1b] px-6 py-3">
                  M&A-Beratung anfragen
                </Button>
              </Link>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default ReferenzenPage;
